var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control date",attrs:{"id":_vm.isId,"type":"text","placeholder":"Scegli data"},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.onBlur($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }